"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ListBoxSection = void 0;
var react_1 = __importDefault(require("react"));
var listbox_1 = require("@react-aria/listbox");
var typography_1 = require("@kaizen/typography");
var Option_1 = require("../Option/Option");
var ListBoxSection_module_scss_1 = __importDefault(require("./ListBoxSection.module.scss"));
var ListBoxSection = function (_a) {
    var section = _a.section;
    var _b = (0, listbox_1.useListBoxSection)({
        heading: section.rendered,
        "aria-label": section["aria-label"]
    }), itemProps = _b.itemProps, headingProps = _b.headingProps, groupProps = _b.groupProps;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("li", __assign({}, itemProps, { className: ListBoxSection_module_scss_1["default"].sectionWrapper }),
            section.rendered && (react_1["default"].createElement(typography_1.Heading, __assign({ variant: "heading-6" }, headingProps, { classNameOverride: ListBoxSection_module_scss_1["default"].sectionHeading }), section.rendered)),
            react_1["default"].createElement("ul", __assign({}, groupProps, { className: ListBoxSection_module_scss_1["default"].sectionList }), Array.from(section.childNodes).map(function (item) { return (react_1["default"].createElement(Option_1.Option, { key: item.key, item: item })); })))));
};
exports.ListBoxSection = ListBoxSection;
exports.ListBoxSection.displayName = "ListBoxSection";
//# sourceMappingURL=ListBoxSection.js.map